// extracted by mini-css-extract-plugin
module.exports = {"header":"SectionHeader_header__ZTi5r","container":"SectionHeader_container___QACl","header__heading":"SectionHeader_header__heading__ZfkzI"};